import { render } from "./LaboratoryListView.vue?vue&type=template&id=7679e90e&scoped=true"
import script from "./LaboratoryListView.vue?vue&type=script&lang=js"
export * from "./LaboratoryListView.vue?vue&type=script&lang=js"

import "./LaboratoryListView.vue?vue&type=style&index=0&id=7679e90e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7679e90e"]])

export default __exports__